import Vue from 'vue'
import Router from 'vue-router'

import guard from '@/router/guard'
import title from '@/router/title'
import routes from '@/router/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes
})

router.beforeEach((to, from, next) => {
  title(to, from, next)
  guard(to, from, next)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js